import { render } from "./InPlaceMessage.vue?vue&type=template&id=6b994292&scoped=true&ts=true"
import script from "./InPlaceMessage.vue?vue&type=script&lang=ts"
export * from "./InPlaceMessage.vue?vue&type=script&lang=ts"

import "./InPlaceMessage.vue?vue&type=style&index=0&id=6b994292&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b994292"]])

export default __exports__